import qs from 'qs';
import client from './rest/AdminClient';
import AdminServerActionCreators from '../actions/AdminServerActionCreators';

export function getFilters(query = {}) {
  return client({
    method: 'GET',
    path: `/api/filters?${qs.stringify(query)}`,
  });
}

export function getFilterNames(query = {}) {
  return client({
    method: 'GET',
    path: `/api/filterNames?${qs.stringify(query)}`,
  });
}

export function getFilter(id) {
  return client({
    method: 'GET',
    path: `/api/filters/${id}`,
  });
}

export function createFilter(data) {
  return client({
    method: 'POST',
    path: '/api/filters',
    entity: JSON.stringify(data),
  });
}

export function updateFilters(updates) {
  return client({
    method: 'PUT',
    path: '/api/filters',
    entity: JSON.stringify(updates),
  });
}

export function deleteFilter(id) {
  const payload = { id };

  return client({
    method: 'DELETE',
    path: '/api/filters',
    entity: JSON.stringify(payload),
  });
}

export default {
  getFilterNames(query) {
    getFilterNames(query)
      .then((result) => {
        AdminServerActionCreators.getAllFiltersSuccess(result.entity);
      })
      .catch((e) => {
        AdminServerActionCreators.alertFiltersCrudFail(e);
      });
  },
  updateFilters(updates) {
    updateFilters(updates)
      .then(() => {
        this.getFilterNames();
      })
      .catch((e) => {
        AdminServerActionCreators.alertFiltersCrudFail(e);
      });
  },
  createFilter(payload) {
    createFilter(payload)
      .then((result) => {
        AdminServerActionCreators.alertFiltersCreated(result.entity);
      })
      .catch((e) => {
        AdminServerActionCreators.alertFiltersCrudFail(e);
      });
  },
  deleteFilter(id) {
    deleteFilter(id)
      .then(() => {
        AdminServerActionCreators.alertFiltersDeleted(id);
      })
      .catch((e) => {
        AdminServerActionCreators.alertFiltersCrudFail(e);
      });
  },
};
